import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

//
var script = {
  name: 'VProducts',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: val => ['default', 'scroll'].includes(val)
    }
  },
  setup(props) {
    const products = ref(null);
    const isMouseDown = ref(false);
    const startX = ref(null);
    const classes = computed(() => ({
      [`v-products--${props.variant}`]: props.variant
    }));
    onMounted(() => {
      if (props.variant === 'scroll') {
        products.value.addEventListener('mousedown', handleMouseDown);
        products.value.addEventListener('mouseup', handleMouseUp);
        products.value.addEventListener('mouseleave', handleMouseUp);
        products.value.addEventListener('mousemove', handleMouseMove);
      }
    });
    onBeforeUnmount(() => {
      if (props.variant === 'scroll') {
        products.value.removeEventListener('mousedown', handleMouseDown);
        products.value.removeEventListener('mouseup', handleMouseUp);
        products.value.removeEventListener('mouseleave', handleMouseUp);
        products.value.removeEventListener('mousemove', handleMouseMove);
      }
    });
    function handleMouseDown(e) {
      isMouseDown.value = true;
      startX.value = e.pageX;
    }
    function handleMouseUp() {
      isMouseDown.value = false;
    }
    function handleMouseMove(e) {
      if (!isMouseDown.value) return;
      e.preventDefault();
      // scroll the container with the drag
      products.value.scrollLeft = products.value.scrollLeft + (startX.value - e.pageX);
      // Reset the start x
      startX.value = e.pageX;
    }
    return {
      products,
      classes
    };
  }
};
export { script as default };